import { FunctionComponent, StrictMode } from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './modules/Auth/contexts/AuthContext'
import { ThemeGeneratorProvider } from '@/theme/contexts/ThemeGeneratorContext'
import { RebrandingThemeGeneratorProvider } from '@/rebrandedTheme/contexts/ThemeGeneratorContext'
import { Settings } from 'luxon'
import './i18n'
import registerServiceWorker from './serviceWorker'

Settings.defaultLocale = 'pt-BR'

const Index: FunctionComponent = () => (
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <RebrandingThemeGeneratorProvider>
          <ThemeGeneratorProvider>
            <App />
          </ThemeGeneratorProvider>
        </RebrandingThemeGeneratorProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>
)

ReactDOM.render(<Index />, document.getElementById('root'))

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

// Service worker
registerServiceWorker()
